module.exports = __webpack_public_path__ + "img/bcym01.384b6005.png";